export default __webpack_public_path__ + "static/media/brochure-icon.1c647676.svg";